export enum FinalizationTypes {
	MANUAL = "manual",
	EXTERNAL = "external",
	BANK_SELECTOR = "bank_selector"
}
